/*
    © 2021 EcomGraduates.com. All rights reserved.
    https://www.ecomgraduates.com
*/

// Init Wishlist
window.initWishlist = () => {
    const wishlist = JSON.parse(localStorage.getItem('eg_bigstore_wishlist')) || []

    document.querySelectorAll('.btn-atw').forEach((btn) => {
        const isWishlisted = wishlist.some((product) => product.id === btn.dataset.productId)

        if (isWishlisted) {
            btn.title = btn.dataset.textRemoveFromWishlist
            btn.classList.add('active')
        } else {
            btn.title = btn.dataset.textAddToWishlist
            btn.classList.remove('active')
        }

        new bootstrap.Tooltip(btn) // eslint-disable-line no-new
    })

    document.querySelectorAll('.wishlist-count-badge').forEach((el) => {
        if (wishlist.length === 0) {
            el.style.display = 'none'
        } else {
            el.style.display = 'block'
        }
    })
}
initWishlist()

// Handle Wishlist Button
window.onClickWishlistBtn = (btn, event) => {
    event.preventDefault()

    bootstrap.Tooltip.getInstance(btn).hide()
    bootstrap.Tooltip.getInstance(btn).disable()

    let wishlist = JSON.parse(localStorage.getItem('eg_bigstore_wishlist')) || []

    if (wishlist.some((product) => product.id === btn.dataset.productId)) {
        wishlist = wishlist.filter((product) => product.id !== btn.dataset.productId)
        btn.title = btn.dataset.textAddToWishlist
        btn.classList.remove('active')
    } else {
        wishlist.push({
            id: btn.dataset.productId,
            title: btn.dataset.productTitle,
            url: btn.dataset.productUrl,
            compare_at_price: btn.dataset.productCompareAtPrice,
            price: btn.dataset.productPrice,
            price_varies: btn.dataset.productPriceVaries,
            img_src: btn.dataset.productImgSrc,
            img_alt: btn.dataset.productImgAlt,
            wishlisted_at: Date.now()
        })
        btn.title = btn.dataset.textRemoveFromWishlist
        btn.classList.add('active')
    }
    localStorage.setItem('eg_bigstore_wishlist', JSON.stringify(wishlist))
    new bootstrap.Tooltip(btn) // eslint-disable-line no-new
    initWishlist()
}

// Load products in offcanvas wishlist
const initOffcanvasWishlist = () => {
    const offcanvas = document.querySelector('#offcanvas-wishlist')
    let wishlist = JSON.parse(localStorage.getItem('eg_bigstore_wishlist')) || []

    if (wishlist.length > 0) {
        let html = ''
        wishlist.forEach((product) => {
            html += `
                <li class="product-list-item">
                    <a href="${product.url}" class="row align-items-center mx-n3 py-3 text-decoration-none">
                        <div class="col-3 px-3">
                            <img 
                                class="product-img img-fluid ${offcanvas.dataset.imgBorder}"
                                src="${window.resizeImage(product.img_src || 'no-image.gif', `${offcanvas.dataset.imgWidth}x${offcanvas.dataset.imgHeight}`, 'center')}"
                                alt="${product.img_alt}" 
                                width="${offcanvas.dataset.imgWidth}"
                                height="${offcanvas.dataset.imgHeight}"
                                loading="lazy">
                        </div>
                        <div class="col-7 px-3">
                            <h5 class="product-title title h6 mb-2">
                                ${product.title}
                            </h5>
                            <p class="product-price-container text-body mb-1">
                                <s class="product-price-compare text-muted me-1 ${product.compare_at_price > product.price ? '' : 'd-none'}">
                                    <span class="visually-hidden">
                                        ${offcanvas.dataset.textOldPrice}
                                    </span>
                                    ${window.formatMoney(product.compare_at_price)}
                                </s>
                                <span class="product-price-final">
                                    <span class="price-from ${product.price_min !== product.price_max ? '' : 'd-none'}">
                                        ${offcanvas.dataset.textPriceFrom}
                                    </span>
                                    ${window.formatMoney(product.price)}
                                </span>
                            </p>
                        </div>
                        <div class="col-2 px-3">
                            <button 
                                class="offcanvas-wishlist-btn-remove btn btn-remove d-flex mx-auto text-muted"
                                aria-label="Remove"
                                data-product-id="${product.id}">
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="20" 
                                    height="20" 
                                    fill="currentColor" 
                                    class="material-icon material-icon-remove" 
                                    viewBox="0 0 24 24">
                                    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path>
                                </svg>
                            </button>
                        </div>
                    </a>
                </li>
            `
            offcanvas.querySelector('#offcanvas-wishlist-empty').style.display = 'none'
            offcanvas.querySelector('#offcanvas-wishlist .product-list').innerHTML = html
            offcanvas.querySelector('#offcanvas-wishlist .product-list').style.display = 'block'
        })
    } else {
        offcanvas.querySelector('#offcanvas-wishlist-empty').style.display = 'block'
        offcanvas.querySelector('#offcanvas-wishlist .product-list').style.display = 'none'
    }

    document.querySelectorAll('.offcanvas-wishlist-btn-remove:not(.init)').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault()

            btn.classList.add('init')

            wishlist = wishlist.filter((product) => product.id !== btn.dataset.productId)
            localStorage.setItem('eg_bigstore_wishlist', JSON.stringify(wishlist))

            initWishlist()
            initOffcanvasWishlist()

            if (wishlist.length === 0) {
                setTimeout(() => {
                    const bsOffcanvas = bootstrap.Offcanvas.getInstance(document.querySelector('#offcanvas-wishlist'))
                    bsOffcanvas?.hide()
                }, 500)
            }
        })
    })
}

document.querySelector('#offcanvas-wishlist').addEventListener('show.bs.offcanvas', () => {
    initOffcanvasWishlist()
})
